<div class="character__list">
  @for (character of characters(); track character) {
    <div class="character__persona">
      <div class="character-image-frame">
        @if (character?.introImage) {
          <img ngSrc="{{ character?.introImage }}" width="360" height="551" alt="" />
        }
      </div>
      <h2 class="character__persona__label">{{ character.label }}</h2>
      <button
        type="button"
        class="character__persona__btn"
        (click)="onFieldClicked(character.label)"
        [attr.aria-label]="'Kies de richting ' + character.label"
      ></button>
    </div>
  }
</div>
